<div class="bento-container">
  <!-- Header wrapped in a card -->
  <div class="bento-card header-card">

    <h1>Get in Touch</h1>
    <p>Have questions or need assistance? We're here to help.</p>
  </div>



  <!-- Success and Error messages -->
  <div *ngIf="showSuccess" class="alert alert-success">
    <i class="bi bi-check-circle-fill me-2"></i>
    Your message has been sent successfully. We will get back to you soon.
  </div>

  <div *ngIf="showError" class="alert alert-danger">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    <span [innerHTML]="errorMessage"></span>
  </div>

  <!-- Bento Grid Layout -->
  <div class="bento-grid">

    <!-- Top Row: Contact Info Cards -->
    <!-- Email Contact Card -->
    <div class="bento-card contact-card">
      <div class="card-icon">
        <i class="bi bi-envelope-fill"></i>
      </div>
      <h3>Email Us</h3>
      <a href="mailto:info@builtgenix.com" class="contact-link">info&#64;builtgenix.com</a>
      <p class="subtitle">We typically respond within 24 hours.</p>
    </div>

    <!-- Phone Contact Card -->
    <div class="bento-card contact-card">
      <div class="card-icon">
        <i class="bi bi-telephone-fill"></i>
      </div>
      <h3>Call Us</h3>
      <a href="tel:3129700336" class="contact-link">312-970-0336</a>
      <p class="subtitle">Monday - Friday, 9:00 AM - 6:00 PM EST</p>
    </div>

    <!-- Hours Card -->
    <div class="bento-card hours-card">
      <div class="card-icon">
        <i class="bi bi-clock-fill"></i>
      </div>
      <h3>Business Hours</h3>
      <ul class="hours-list">
        <li>
          <span class="day">Monday - Friday:</span>
          <span class="time">9:00 AM - 6:00 PM (EST)</span>
        </li>
        <li>
          <span class="day">Saturday:</span>
          <span class="time">10:00 AM - 2:00 PM (EST)</span>
        </li>
      </ul>
    </div>

    <!-- LinkedIn Card -->
    <div class="bento-card linkedin-card">
      <h3>Follow us on LinkedIn</h3>
      <a href="https://www.linkedin.com/company/builtgenix/" target="_blank" class="linkedin-icon">
        <i class="bi bi-linkedin"></i>
      </a>
    </div>

   <!-- Demo Project Card -->
   <div class="bento-card demo-project-card">
    <div class="card-content">
      <img src="https://bgdevblobstorage.blob.core.windows.net/demo/demo%2B%2BType%2B%2BSINGLEFAMILY.png" alt="Demo Project Example" class="demo-image">
      <div class="card-overlay">
        <h2>Single Family Home Demo</h2>
        <p>See how Builtgenix delivers comprehensive solutions for residential construction projects.</p>
        <a href="https://portal.builtgenix.com/demorequest" class="demo-btn">Request Demo</a>
      </div>
    </div>
  </div>

    <!-- FAQ Card -->
    <div class="bento-card faq-card">
      <div class="card-header">
        <h3>Frequently Asked Questions</h3>
      </div>
      <div class="card-content">
        <div class="accordion">
          <div class="accordion-item">
            <button class="accordion-button">How do I get started with Builtgenix?</button>
            <div class="accordion-content">
              <p>You can request a demo from our website or contact our sales team directly for a personalized onboarding experience.</p>
            </div>
          </div>
          <div class="accordion-item">
            <button class="accordion-button">What support options are available?</button>
            <div class="accordion-content">
              <p>We offer email support, phone support during business hours, and an online knowledge base for self-service help.</p>
            </div>
          </div>
          <div class="accordion-item">
            <button class="accordion-button">Do you provide implementation assistance?</button>
            <div class="accordion-content">
              <p>Yes, our professional services team offers implementation, training, and ongoing support to ensure your success with our platform.</p>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Contact Form Card -->
    <div class="bento-card form-card">
      <div class="card-header text-center">
        <h2>Send Us a Message</h2>
      </div>
      <div class="card-content">
        <form [formGroup]="contactForm" (ngSubmit)="submitForm()">
          <div class="form-group">
            <label for="name">Your Name</label>
            <input
              type="text"
              id="name"
              formControlName="name"
              class="form-control"
              [ngClass]="{'is-invalid': hasError('name', 'required') || hasError('name', 'maxlength') || hasError('name', 'validateNotEmptyInput')}"
              placeholder="Enter your name"
            />
            <div class="validation-message" *ngIf="contactForm.get('name')?.touched">
              <div *ngIf="hasError('name', 'required') || hasError('name', 'validateNotEmptyInput')">
                Name is required
              </div>
              <div *ngIf="hasError('name', 'maxlength')">
                Name cannot exceed 100 characters
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="email">Your Email</label>
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-control"
              [ngClass]="{'is-invalid': hasError('email', 'required') || hasError('email', 'email') || hasError('email', 'maxlength') || hasError('email', 'validateNotEmptyInput')}"
              placeholder="Enter your email"
            />
            <div class="validation-message" *ngIf="contactForm.get('email')?.touched">
              <div *ngIf="hasError('email', 'required') || hasError('email', 'validateNotEmptyInput')">
                Email is required
              </div>
              <div *ngIf="hasError('email', 'email')">
                Please enter a valid email address
              </div>
              <div *ngIf="hasError('email', 'maxlength')">
                Email cannot exceed 100 characters
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="message">Your Message</label>
            <textarea
              id="message"
              formControlName="message"
              class="form-control"
              [ngClass]="{'is-invalid': hasError('message', 'required') || hasError('message', 'minlength') || hasError('message', 'maxlength') || hasError('message', 'validateNotEmptyInput')}"
              placeholder="Type your message here..."
              rows="5"
            ></textarea>
            <div class="validation-message" *ngIf="contactForm.get('message')?.touched">
              <div *ngIf="hasError('message', 'required') || hasError('message', 'validateNotEmptyInput')">
                Message is required
              </div>
              <div *ngIf="hasError('message', 'minlength')">
                Message must be at least 10 characters
              </div>
              <div *ngIf="hasError('message', 'maxlength')">
                Message cannot exceed 1000 characters
              </div>
            </div>
          </div>

          <!-- Turnstile CAPTCHA -->
          <div class="form-group">
            <app-turnstile
              [siteKey]="siteKey"
              (tokenChange)="onTurnstileToken($event)"
              #turnstileWidget
            ></app-turnstile>
          </div>

          <div class="button-container">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="contactForm.invalid || isSubmitting || !turnstileToken"
            >
              {{ isSubmitting ? 'Sending...' : 'Send Message' }}
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>
